import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DxDataGridModule, DxFormModule } from 'devextreme-angular';
import { AuthGuardWithForcedLogin } from 'acl-cloud-lib';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    component: DashboardPageComponent,
    canActivate: [AuthGuardWithForcedLogin],
    data: { breadcrumb: false },
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'machines',
    loadChildren: () => import('../app/pages/machine-info/machine-info.module').then(m => m.MachineInfoModule),
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'current-machine',
    loadChildren: () => import('../app/pages/current-machine/current-machine.module').then(m => m.CurrentMachineModule),
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'machine/:id',
    loadChildren: () => import('../app/pages/current-machine/current-machine.module').then(m => m.CurrentMachineModule),
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'administration',
    loadChildren: () => import('../app/pages/administration/administration.module').then(m => m.AdministrationModule),
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'colaboration',
    loadChildren: () => import('../app/pages/colaboration/colaboration.module').then(m => m.ColaborationModule),
    canActivate: [AuthGuardWithForcedLogin]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true }), DxDataGridModule, DxFormModule],
  providers: [ AuthGuardWithForcedLogin ],
  exports: [ RouterModule ],
})
export class AppRoutingModule { }
